import { flushComposerDraftWriter } from '@/components/org-chat/composer-draft-writer';
import { composerDraftStorageKey } from '@/components/org-chat/composer-draft-storage';

export type NavigationDraftCheckpoint = { key: string; value: string };
export function captureBrowserNavigationDraft(
  actorId: string,
  orgSlug: string
) {
  try {
    flushComposerDraftWriter(composerDraftStorageKey({ actorId, orgSlug }));
    return captureNavigationDraft(window.sessionStorage, actorId, orgSlug);
  } catch {
    return undefined;
  }
}
export function clearBrowserNavigationDraft(
  checkpoint?: NavigationDraftCheckpoint
) {
  try {
    if (checkpoint) flushComposerDraftWriter(checkpoint.key);
    clearAcceptedNavigationDraft(window.sessionStorage, checkpoint);
  } catch {
    /* Private browsing can deny access to the storage object itself. */
  }
}
export function captureNavigationDraft(
  storage: Pick<Storage, 'getItem'>,
  actorId: string,
  orgSlug: string
): NavigationDraftCheckpoint | undefined {
  try {
    const key = composerDraftStorageKey({ actorId, orgSlug });
    const value = storage.getItem(key);
    return value === null ? undefined : { key, value };
  } catch {
    return undefined;
  }
}
/** Settlement may run after /design unmounts. Never erase a newer saved draft. */
export function clearAcceptedNavigationDraft(
  storage: Pick<Storage, 'getItem' | 'removeItem'>,
  checkpoint?: NavigationDraftCheckpoint
) {
  if (!checkpoint) return;
  try {
    if (storage.getItem(checkpoint.key) === checkpoint.value)
      storage.removeItem(checkpoint.key);
  } catch {
    /* Storage availability must not change a successful delivery receipt. */
  }
}
